import { UserTimeKeeping } from "../models/timekeepingModels";
export const SUCCESS_RESPONSE = 200;
export const INITIAL_USER:UserTimeKeeping = {
  officeHour: 8,
  overtimeHour: 0,
  member: {
    name: "le van dung",
    code: "12345",
    position:"be fe "
  }
}

export const ROWS_FOR_PAGE:number[] = [2,5,10,20]